export const PARTNER_DISCLOSURE =
  "Some links here are partner/affiliate links, and RouteHaul may earn a commission at no extra cost to you. These open third-party sites (such as GPS/navigation, insurance, factoring and fuel providers). If you enter any information on those sites, it is collected and used under their own privacy policy — not ours.";

export const PARTNER_CATEGORIES = [
  {
    id: "gps",
    label: "Truck GPS & Navigation",
    steps: [11],
    items: [
      { id: "gps-garmin", name: "Garmin dēzl", url: "https://www.garmin.com/en-US/c/automotive/trucking-navigation/", desc: "Truck-specific GPS navigators built for owner-operators." },
      { id: "gps-randmcnally", name: "Rand McNally", url: "https://www.randmcnally.com/category/gps-devices", desc: "Truck GPS units with load-based routing and truck stops." },
      { id: "gps-truckerpath", name: "Trucker Path", url: "https://truckerpath.com", desc: "App for truck parking, weigh stations, fuel and routing." },
    ],
  },
  {
    id: "insurance",
    label: "Commercial Insurance",
    steps: [4],
    items: [
      { id: "ins-progressive", name: "Progressive Commercial", url: "https://www.progressivecommercial.com", desc: "Commercial trucking insurance." },
      { id: "ins-reliance", name: "Reliance Partners", url: "https://www.reliancepartners.com", desc: "Trucking insurance brokerage." },
      { id: "ins-tis", name: "The Insurance Store (TIS)", url: "https://www.tiscorp.com", desc: "Truck insurance specialists." },
    ],
  },
  {
    id: "factoring",
    label: "Factoring",
    steps: [10],
    items: [
      { id: "fac-apex", name: "Apex Capital", url: "https://www.apexcapitalcorp.com", desc: "Freight factoring with same-day funding." },
      { id: "fac-otr", name: "OTR Solutions", url: "https://www.otrsolutions.com", desc: "Non-recourse factoring for new carriers." },
      { id: "fac-rts", name: "RTS Financial", url: "https://www.rtsinc.com", desc: "Factoring plus fleet services." },
    ],
  },
  {
    id: "fuel",
    label: "Fuel Cards",
    steps: [10],
    items: [
      { id: "fuel-wex", name: "WEX Fleet Cards", url: "https://www.wexinc.com", desc: "Fleet fuel cards with discounts and controls." },
      { id: "fuel-tcs", name: "TCS Fuel Card", url: "https://www.tcsfuel.com", desc: "No-fee fuel card for owner-operators." },
      { id: "fuel-rts", name: "RTS Fuel Card", url: "https://www.rtsinc.com/fuel-card", desc: "Fuel discounts at a nationwide network." },
    ],
  },
];

export const getPartnersForStep = (n) =>
  PARTNER_CATEGORIES.filter((c) => c.steps.includes(Number(n)));

export const withUtm = (url, { campaign, content } = {}) => {
  try {
    const u = new URL(url);
    u.searchParams.set("utm_source", "routehaul");
    u.searchParams.set("utm_medium", "playbook");
    if (campaign) u.searchParams.set("utm_campaign", campaign);
    if (content) u.searchParams.set("utm_content", content);
    return u.toString();
  } catch {
    return url;
  }
};
